import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import KanbanCard from './KanbanCard';
import { getOperacaoLocal } from 'helpers/auth';

const KanbanContainerImportacao = ({ dados, operacao }) => {
  const containerRef = useRef(null);
  return (
    <>
      <div className="kanban-container me-n3 scrollbar" ref={containerRef}>
        {operacao === 'IMPORTAÇÃO' ? (
          <>
            {/* AGUARDANDO EMBARQUE */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '1')}
              title={'Aguarda Embarque'}
              ordem={1}
            />
            {/* EMBARCADO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '2')}
              title={'Aguarda Chegada'}
              ordem={2}
            />

            {/* DESEMBARCADO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '3')}
              title={'Aguarda Registro DI'}
              ordem={3}
            />

            {/* DESEMBARAÇO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '4')}
              title={'Aguarda Desembaraço'}
              ordem={4}
            />

            {/* DESEMBARAÇADA */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '5')}
              title={'Aguarda Envio Faturamento'}
              ordem={5}
            />

            {/* CONCLUIDO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '6')}
              title={'Aguarda Encerramento'}
              ordem={6}
            />

            {/* CONCLUIDO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '7')}
              title={'Encerrado'}
              ordem={7}
            />

             {/* CANCELADO */}
             <KanbanCard
              dados={dados.filter(processos => processos.ordem === '8')}
              title={'Cancelado(s)'}
              ordem={8}
            />
          </>
        ) : (
          <>
            {/* AGUARDANDO EMBARQUE */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '1')}
              title={'Ag. Desembaraço'}
              ordem={1}
            />
            {/* EMBARCADO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '2')}
              title={'Ag. Embarque'}
              ordem={2}
            />

            {/* DESEMBARCADO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '3')}
              title={'Embarcado(s)'}
              ordem={3}
            />

            {/* CANCELADO */}
            <KanbanCard
              dados={dados.filter(processos => processos.ordem === '4')}
              title={'Cancelado(s)'}
              ordem={4}
            />
          </>
        )}
      </div>
    </>
  );
};

KanbanContainerImportacao.propTypes = { dados: PropTypes.object };

export default KanbanContainerImportacao;
